import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authState = inject(AuthStateService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authState.isLoggedIn) return true;

  const refreshedToken = await authService.refreshToken();
  if (refreshedToken) return true;

  authState.returnToPath = state.url;
  router.navigate(['/login']);
  return false;
};

export const publicOnlyGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);
  return authState.isLoggedIn ? router.createUrlTree(['/top']) : true;
};
